import { Loader2, TrendingUp } from "lucide-react";
import { useVendorSales } from "@/hooks/useVendor";
import { formatPrice, formatDate } from "@/lib/format";

export default function VendorSales() {
  const { data: sales, isLoading } = useVendorSales();
  const total = (sales || []).reduce((s, x) => s + (x.amount || 0), 0);
  return (
    <div className="space-y-5" data-testid="vendor-sales">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-extrabold text-ink">Mes ventes</h1>
          <p className="mt-1 text-sm text-slate-500">Historique de vos ventes confirmées.</p>
        </div>
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-2 text-right">
          <p className="text-[11px] font-bold uppercase text-emerald-600">Total encaissé</p>
          <p className="font-display text-lg font-extrabold text-emerald-700">{formatPrice(total)}</p>
        </div>
      </div>
      {isLoading ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
      ) : !sales?.length ? (
        <div className="rounded-2xl border border-dashed border-line bg-white p-10 text-center">
          <TrendingUp className="mx-auto h-9 w-9 text-slate-300" />
          <p className="mt-3 text-sm text-slate-500">Aucune vente confirmée pour le moment.</p>
        </div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-line bg-white">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-line text-left text-[11px] uppercase tracking-wide text-slate-400">
              <th className="p-4">Date</th><th className="p-4">Produit</th><th className="p-4">Client</th><th className="p-4">Qté</th><th className="p-4">Montant</th><th className="p-4">Commande</th>
            </tr></thead>
            <tbody className="divide-y divide-line">
              {sales.map((s, i) => (
                <tr key={i} data-testid={`vsale-${i}`}>
                  <td className="p-4 text-slate-500">{formatDate(s.date)}</td>
                  <td className="p-4 font-semibold text-ink">{s.product}</td>
                  <td className="p-4 text-slate-600">{s.customer}</td>
                  <td className="p-4">{s.quantity}</td>
                  <td className="p-4 font-bold text-emerald-600">{formatPrice(s.amount)}</td>
                  <td className="p-4 text-xs text-slate-400">{s.order_number}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
